import { v4 as uuid } from 'uuid'
export interface IBarcode {
  id: string
  upc: string
  title: string
  description: string
  brand: string
  model: string
  dimension: string
  weight: string
  image: string
  category: string
}

export class Barcode implements IBarcode {
  public id: string = uuid()
  public upc: string = ''
  public title: string = ''
  public description: string = ''
  public brand: string = ''
  public model: string = ''
  public dimension: string = ''
  public weight: string = ''
  public image: string = ''
  public category: string = ''

  public get name() {
    const cleanTitle = this.title.replace(new RegExp(`^${ this.brand } `), '')
    return [this.brand, cleanTitle].filter((value: string) => !!value).join(' - ')
  }
}
